import styled from 'styled-components';
export const AIIconContainer = styled.div.withConfig({
  displayName: "AIIconContainers__AIIconContainer",
  componentId: "sc-1vbweqq-0"
})(["display:inline-block;overflow:hidden;width:1em;margin-bottom:-0.15em;"]);